import api from "@/store/api";
import axios from "axios";
import {filterByDate, getWeeksDifference, isInWeeklySequence, isMonthlySequence} from "@/store/utils";

export const state = {
  data: {
    results: []
  },
  entity: {
    city: ''
  },
  selectedColumn: {
    id: '',
    state: 'preview',
    data: {}
  },
  predefinedTags: {
    positive: 'sentiment',
    neutral: 'sentiment',
    negative: 'sentiment',
    full_control: 'control',
    partial_control: 'control',
    no_control: 'control',
    not_this_entity: 'entity',
  },
  scraping: false,
  startDate: '01/01/2024',
  cadence: 'daily'
}

export const mutations = {
  SET_DATA (state, data) {
    state.data = data
  },
  HANDLE_SELECTED_COLUMN (state, data) {
    state.selectedColumn = {
      ...state.selectedColumn,
      ...data
    }
  },
  CANCEL_TAG_EDITING (state) {
    const colIndex = state.data.results.findIndex(o => o.id === state.selectedColumn.id)
    state.data.results[colIndex] = state.selectedColumn.data
    state.selectedColumn = {
      state: 'preview'
    }
  },
  RESET_ENTITY (state) {
    state.data = {}
    state.entity = {}
  },
  SET_D_STATE (state, {key, data}) {
    state[key] = data
  },
  SET_START_DATE (state, date) {
    state.startDate = date
  },
  DELETE_ENTITY_RESULT (state, {_id, resultId}) {
    const entityIndex = state.data.results.findIndex(o => o._id === _id)
    // const index = state.data.results[index][]
  },
  ADD_SCRAPE_RESULT (state, results) {
    state.data.results?.unshift(results)
  },
  SET_TAG (state, {key, value, resultId}) {
    const id = state.selectedColumn.id
    const index = state.data.results.findIndex(o => o.id === id)
    const resultIndex = state.data.results[index].leftSide.findIndex(o => o.id === resultId)
    // remove the tag if it exists and it was clicked on it
    const tag = state.data.results[index].leftSide[resultIndex].tags[key]
    if (tag && tag === value) {
      delete state.data.results[index].leftSide[resultIndex].tags[key]
    } else {
      state.data.results[index].leftSide[resultIndex].tags[key] = value
    }
  },
}

export const actions = {
  async get_entity_data ({state, commit}, _id) {
    try {
      let url = `${api.entities}/${_id}`
      const { data } = await axios.get(url)
      commit('SET_DATA', data)
    } catch (err) {
      console.log(err)
    }
  },
  async scrape_entity ({state, commit}, _id) {
    try {
      commit('SET_D_STATE', {key: 'scraping', data: true})
      const url = `${api.entities}/scrape/${_id}`
      const { data } = await axios.get(url)
      // add the scraped results to the existing data array
      commit('ADD_SCRAPE_RESULT', data)
      commit('SET_D_STATE', {key: 'scraping', data: false})
    } catch (err) {
      console.log(err)
      commit('SET_D_STATE', {key: 'scraping', data: false})
    }
  },
  async save_tags({ state, commit }) {
    try {
      const url = `${api.entities}/${state.data._id}/tags`;
      const currentResult = state.data.results[
        state.data.results.findIndex(o => o.id === state.selectedColumn.id)
        ];

      // Send the current result to be synced
      const { data } = await axios.put(url, currentResult);

      // Update local state with synced data
      commit('SET_DATA', data);
      commit('HANDLE_SELECTED_COLUMN', { state: 'preview' });

    } catch (err) {
      console.error('Error syncing tags:', err);
    }
  }
}

export const getters = {
  results: state => {
    if (state.cadence === 'weekly') {
      return state.data.results.filter((o, index) => isInWeeklySequence(new Date(state.startDate), new Date(o.scrapedAt)))
    }
    if (state.cadence === 'monthly') {
      return state.data.results.filter((o, index) => isMonthlySequence(new Date(state.startDate), new Date(o.scrapedAt)))
    }
    return state.data.results
  },
}